import React from 'react';
import { Link as RRLink } from 'react-router-dom';
import MuiLink from '@material-ui/core/Link';

const Link = React.forwardRef(function Link(props, ref) {
  return <MuiLink component={RRLink} ref={ref} {...props} />;
});

export default Link;
